/**
 * Rex UI Plugins Configuration
 *
 * Este archivo configura los plugins de Rex UI para Phaser 3.
 * Documentación: https://rexrainbow.github.io/phaser3-rex-notes/docs/site/ui-overview/
 *
 * Componentes disponibles:
 * - Buttons, GridButtons: Grupos de botones con estados
 * - Dialog, ConfirmDialog: Popups y confirmaciones
 * - Toast: Notificaciones flotantes
 * - Slider, NumberBar, Knob: Controles deslizantes
 * - ScrollablePanel, GridTable: Contenido scrolleable
 * - Label, TitleLabel: Etiquetas con icono y fondo
 * - Tabs, Pages: Navegación por pestañas
 * - TextBox: Diálogos de texto con typing effect
 * - Sizer, GridSizer: Layouts automáticos
 */

import UIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';

/**
 * Configuración del plugin Rex UI para escenas
 *
 * Uso en game.ts:
 * ```
 * plugins: {
 *   scene: [rexUIConfig]
 * }
 * ```
 */
export const rexUIConfig: Phaser.Types.Core.PluginObjectItem = {
  key: 'rexUI',
  plugin: UIPlugin,
  mapping: 'rexUI'
};

/**
 * Declaración de tipos para TypeScript
 * Esto permite usar this.rexUI en las escenas sin errores de tipo
 */
declare module 'phaser' {
  interface Scene {
    rexUI: UIPlugin;
  }
}

export { UIPlugin };
